import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ResourceMatchesStatus } from '~/types';
import {
  ResourceMatchItemError,
  ResourceMatchItemNoMatches,
  ResourceMatchItemCalculating,
  ResourceMatchItemMatch
} from './components';
import { RESOURCE_MATCH_ITEM_BUTTONS } from './enums';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(0.5, 1),
    width: '100%'
  }
}));

export const ResourceMatchItem = ({
  classes: classesOverride,
  matchClasses: matchClassesOverride,
  dataQeId,
  resourceRequest,
  buttonType,
  setAnchorEl,
  setPopoverResourceRequest,
  project
}) => {
  const classes = useStyles({ classes: classesOverride });
  const resourceMatchesLength = resourceRequest.resourceMatches?.length;
  const dataQeId2 = dataQeId
    ? `${dataQeId}_ResourceMatchItem`
    : 'ResourceMatchItem';

  return (
    <div data-qe-id={dataQeId2} className={classes.root}>
      {resourceRequest.resourceMatchesStatus ===
      ResourceMatchesStatus.Completed ? (
        resourceMatchesLength > 0 ? (
          <ResourceMatchItemMatch
            matchClasses={matchClassesOverride}
            resourceRequest={resourceRequest}
            buttonType={buttonType}
            setAnchorEl={setAnchorEl}
            setPopoverResourceRequest={setPopoverResourceRequest}
            project={project}
          />
        ) : (
          <ResourceMatchItemNoMatches dataQeId={dataQeId2} />
        )
      ) : resourceRequest.resourceMatchesStatus ===
        ResourceMatchesStatus.InProgress ? (
        <ResourceMatchItemCalculating
          dataQeId={dataQeId2}
          resourceRequest={resourceRequest}
        />
      ) : (
        <ResourceMatchItemError dataQeId={dataQeId2} />
      )}
    </div>
  );
};

ResourceMatchItem.propTypes = {
  dataQeId: PropTypes.string,
  classes: PropTypes.object,
  matchClasses: PropTypes.object,
  resourceRequest: PropTypes.object.isRequired,
  buttonType: PropTypes.oneOf(Object.values(RESOURCE_MATCH_ITEM_BUTTONS))
    .isRequired,
  setAnchorEl: PropTypes.func.isRequired,
  setPopoverResourceRequest: PropTypes.func.isRequired,
  project: PropTypes.object.isRequired
};

export default ResourceMatchItem;
